import { cloudFunctionsAxios } from './axios';

/**
 * Setup inbound phone number with Bland.ai
 * This configures the phone number to receive inbound calls through Bland.ai's API
 * @param phoneNumber The phone number to configure (E.164 format)
 * @param organizationId The organization ID
 * @param encryptedKey The Twilio encrypted key (optional, for BYOT)
 * @returns A promise that resolves to the setup result
 */
export const setupBlandInboundNumber = async (
  phoneNumber: string,
  organizationId: string,
  encryptedKey?: string
) => {
  try {
    const payload: {
      phone_number: string;
      organization_id: string;
      encrypted_key?: string;
    } = {
      phone_number: phoneNumber,
      organization_id: organizationId,
    };

    if (encryptedKey) {
      payload.encrypted_key = encryptedKey;
    }

    const response = await cloudFunctionsAxios.post('/blandInboundSetup', payload);

    return response.data;
  } catch (error) {
    console.error('Error setting up Bland inbound number:', error);
    throw error;
  }
};
